export default __webpack_public_path__ + "static/media/metavertical.1581c305.png";